import { AxiosInstance } from 'axios';
import { IPeopleSearchRequest, IPeopleSearchResult } from '../interfaces/IPeopleSearch';
import { IPagedFilterResponse } from '../interfaces/IPagedFilterResponse';

export class PeopleSearchService {
    private readonly baseUrl = '/participant/people';
    private readonly apiClient: AxiosInstance;

    constructor(apiClient: AxiosInstance) {
        this.apiClient = apiClient;
    }

    async search(request: IPeopleSearchRequest, signal?: AbortSignal): Promise<IPagedFilterResponse<IPeopleSearchResult>> {
        const params: Record<string, string | number | boolean> = {};

        if (request.query) params.query = request.query;
        if (request.scope) params.scope = request.scope;
        if (request.eventId) params.eventId = request.eventId;
        if (request.communityId) params.communityId = request.communityId;
        if (request.connection) params.connection = request.connection;
        if (request.allowConnectionsOnly) params.allowConnectionsOnly = true;
        if (request.sharedEventsOnly) params.sharedEventsOnly = true;
        if (request.mutualConnectionsOnly) params.mutualConnectionsOnly = true;
        if (request.industry) params.industry = request.industry;
        if (request.sortBy) params.sortBy = request.sortBy;
        if (request.sortDesc) params.sortDesc = true;
        params.page = request.page ?? 1;
        params.pageSize = request.pageSize ?? 20;

        const response = await this.apiClient.get(`${this.baseUrl}/search`, { params, ...(signal ? { signal } : {}) });
        return response.data;
    }

    async sendConnectionRequest(otherUserId: string): Promise<void> {
        await this.apiClient.post('/participant/connections', JSON.stringify(otherUserId), {
            headers: { 'Content-Type': 'application/json' },
        });
    }
}
